import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../../utils/helpers";
import { styles } from "./adminStyles";

// Iki arayuz secenegi: Altin (klasik modern altin) ve Koyu ve Acik (yeni pro tema, kendi toggle'i var)
const INTERFACES = [
  {
    key: 'modern',
    label: 'Altın',
    desc: 'Klasik krem + altın modern arayüz',
    preview: 'linear-gradient(135deg, #F5F3EF 0%, #FFFFFF 50%, #E8D5B5 100%)',
    accent: '#e09b47',
  },
  {
    key: 'proauto',
    label: 'Koyu ve Açık',
    desc: 'Profesyonel arayüz — sayfada koyu/açık geçiş butonu',
    preview: 'linear-gradient(135deg, #0A0A0B 0%, #16161A 55%, #D4AF37 100%)',
    accent: '#D4AF37',
  },
];

const ArayuzTab = ({ profile, currentUserName }) => {
  const [selected, setSelected] = useState("modern");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API}/admin/theme?profile=${profile}`);
        // Eski tema/layout degerleri artik desteklenmiyor -> proauto disindaki her sey Altin(modern)
        setSelected(res.data.theme === 'proauto' ? 'proauto' : 'modern');
      } catch (e) { console.error(e); }
    };
    load();
  }, [profile]);

  const save = async () => {
    try {
      await axios.post(`${API}/admin/theme?profile=${profile}`, { theme: selected, layout: 'modern' });
      setSuccess("Arayüz değiştirildi! Sayfa yenilenecek...");
      setTimeout(() => { window.location.reload(); }, 1500);
    } catch (e) { console.error(e); }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '30px 20px' }}>
      <div style={{ maxWidth: '760px', width: '100%' }}>
        <h1 style={{ color: 'var(--adm-canvas-title)', textAlign: 'center', marginBottom: '10px', fontSize: '1.5rem' }}>Arayüz Seçimi - {currentUserName}</h1>
        {success && <p style={styles.success} data-testid="arayuz-success">{success}</p>}

        <p style={{ color: 'var(--adm-canvas-sub)', textAlign: 'center', marginBottom: '18px', fontSize: '14px' }}>İki arayüzden birini seçin</p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '18px', marginBottom: '25px' }}>
          {INTERFACES.map(it => (
            <div
              key={it.key}
              onClick={() => setSelected(it.key)}
              data-testid={`interface-${it.key}-btn`}
              style={{
                background: '#1e293b',
                border: selected === it.key ? `3px solid ${it.accent}` : '2px solid #3b4a5f',
                borderRadius: '16px', padding: '18px', cursor: 'pointer', transition: 'all 0.25s', textAlign: 'center',
              }}
            >
              <div style={{ width: '100%', height: '90px', background: it.preview, borderRadius: '12px', marginBottom: '14px', border: `1px solid ${it.accent}` }} />
              <h3 style={{ color: it.accent, marginBottom: '6px', fontSize: '18px', fontWeight: 700 }}>{it.label}</h3>
              <p style={{ color: '#94a3b8', fontSize: '12px', margin: 0 }}>{it.desc}</p>
              {selected === it.key && <span style={{ color: '#DA9F54', fontSize: '18px', display: 'block', marginTop: '8px' }}>{'\u2713'}</span>}
            </div>
          ))}
        </div>

        <button onClick={save} style={styles.saveButton} data-testid="save-theme-btn">Kaydet</button>
        <button onClick={() => window.location.href = profile === "default" ? "/" : `/${profile}`} style={{ ...styles.backButton, marginTop: '10px', display: 'block', width: '100%' }}>
          Fiyat Sayfasına Dön
        </button>
      </div>
    </div>
  );
};

export default ArayuzTab;
